import { queryChannels } from '@wix/ambassador-video-v3-channel/http';
export const fetchChannelIds = async httpClient => {
  try {
    const LIMIT = 10;
    let cursor;
    const allChannelIds = [];
    do {
      var _channels$filter, _paging$cursors;
      const {
        data: {
          paging,
          channels
        }
      } = await httpClient.request(queryChannels({
        query: {
          cursorPaging: {
            cursor,
            limit: LIMIT
          },
          fields: ['id']
        }
      }));
      const currentChannelIds = channels == null || (_channels$filter = channels.filter(_ref => {
        let {
          id
        } = _ref;
        return id !== undefined;
      })) == null ? void 0 : _channels$filter.map(_ref2 => {
        let {
          id
        } = _ref2;
        return id;
      });
      allChannelIds.push(...(currentChannelIds ?? []));
      cursor = paging == null || (_paging$cursors = paging.cursors) == null ? void 0 : _paging$cursors.next;
    } while (cursor);
    return allChannelIds;
  } catch (e) {
    return [];
  }
};
//# sourceMappingURL=fetch-channel-ids.js.map